export const userInputs = [
  {
    id: "username",
    label: "Username",
    type: "text",
    placeholder: "Account_user_name",
  },
  {
    id: "email",
    label: "Email",
    type: "email",
    placeholder: "your_email@gmail.com",
  },
  
  {
    id: "password",
    label: "Password",
    type: "password",
  },
  
];
// export const dataInputs = [
//   {
//     id: "grade",
//     label: "Grade",
//     type: "number",
//     placeholder: "Your_Grade",
//   },
//   {
//     id: "subject",
//     label: "Subject",
//     type: "text",
//     placeholder: "your_Subject",
//   },
//   {
//     id: "chapterCount",
//     label: "ChapterCount",
//     type: "number",
//     placeholder: "Your_ChapterCount",
//   }
// ];
export const courseInputs = [
  {
    id: "name",
    label: "Course Name",
    type: "text",
    placeholder: "Your_Course_Name",
  },
  {
    id: "text",
    label: "Course Text",
    type: "text",
    placeholder: "Your_Course_Text",
  },
  {
    id: "duration",
    label: "Course Duration",
    type: "text",
    placeholder: "Your_Course_Duration",
  },
  {
    id: "fees",
    label: "Course Fees",
    type: "text",
    placeholder: "Your_Course_Fees",
  },
  {
    id: "eligibility",
    label: "Course Eligibility",
    type: "text",
    placeholder: "Your_Course_Eligibility",
  },
  {
    id: "universities",
    label: "Course Universities",
    type: "text",
    placeholder: "Your_Course_Universities",
  },
  {
    id: "about",
    label: "About Course",
    type: "text",
    placeholder: "about_Your_Course",
  },
  {
    id: "fullform",
    label: "Course fullform",
    type: "text",
    placeholder: "Course Fullform",
  }
];
export const blogInputs = [
  { id: "title", label: "Title", type: "text", placeholder: "Blog title" },
  // { id: "slug", label: "Slug", type: "text", placeholder: "seo-friendly-url" },
  { id: "content", label: "Content", type: "textarea", placeholder: "Full blog content" },
  { id: "author", label: "Author", type: "text", placeholder: "Blog author" },
  // { id: "imageUrl", label: "Image URL", type: "text", placeholder: "Thumbnail image" },
  { id: "seoKeywords", label: "SEO Keywords", type: "text", placeholder: "comma,separated,keywords" },
  { id: "seoDescription", label: "SEO Description", type: "text", placeholder: "Meta description" },
];

// export const chapdetailInputs = [
//   {
//     id: "chapterName",
//     label: "ChapterName",
//     type: "text",
//     placeholder: "Your_chapterName",
//   }
// ];
// export const subtopicInputs = [
//   {
//     id: "SubTopic",
//     label: "SubTopicName",
//     type: "text",
//     placeholder: "Your_subtopicName",
//   }
// ];
// export const sessionInputs = [
//   {
//     id: "topic",
//     label: "SessionName",
//     type: "text",
//     placeholder: "Your_sessionName",
//   }
// ];
// export const allquestionInputs = [
//   {
//     id: "question",
//     label: "Question",
//     type: "text",
//     placeholder: "Your_question",
//   },
//   {
//     id: "correctAnswer",
//     label: "Correct Answer",
//     type: "text",
//     placeholder: "Your_correctAnswer",
//   }
// ];

// export const productInputs = [
//   {
//     id: 1,
//     label: "Title",
//     type: "text",
//     placeholder: "Apple Macbook Pro",
//   },
//   {
//     id: 2,
//     label: "Description",
//     type: "text",
//     placeholder: "Description",
//   },
//   {
//     id: 3,
//     label: "Category",
//     type: "text",
//     placeholder: "Computers",
//   },
//   {
//     id: 4,
//     label: "Price",
//     type: "text",
//     placeholder: "100",
//   },
//   {
//     id: 5,
//     label: "Stock",
//     type: "text",
//     placeholder: "in stock",
//   },
// ];

// export const hotelInputs = [
//   {
//     id: "name",
//     label: "Name",
//     type: "text",
//     placeholder: "My Hotel",
//   },
//   {
//     id: "type",
//     label: "Type",
//     type: "text",
//     placeholder: "hotel",
//   },
//   {
//     id: "city",
//     label: "City",
//     type: "text",
//     placeholder: "New York",
//   },
//   {
//     id: "address",
//     label: "Address",
//     type: "text",
//     placeholder: "elton st, 216",
//   },
//   {
//     id: "distance",
//     label: "Distance from City Center",
//     type: "text",
//     placeholder: "500",
//   },
//   {
//     id: "title",
//     label: "Title",
//     type: "text",
//     placeholder: "The best Hotel",
//   },
//   {
//     id: "desc",
//     label: "Description",
//     type: "text",
//     placeholder: "description",
//   },
//   {
//     id: "cheapestPrice",
//     label: "Price",
//     type: "text",
//     placeholder: "100",
//   },
// ];

// export const roomInputs = [
//   {
//     id: "title",
//     label: "Title",
//     type: "text",
//     placeholder: "2 bed room",
//   },
//   {
//     id: "desc",
//     label: "Description",
//     type: "text",
//     placeholder: "King size bed, 1 bathroom",
//   },
//   {
//     id: "price",
//     label: "Price",
//     type: "number",
//     placeholder: "100",
//   },
//   {
//     id: "maxPeople",
//     label: "Max People",
//     type: "number",
//     placeholder: "2",
//   },
// ];